import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import { useState } from "react";
import Stack from "@mui/material/Stack";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
//OAERDOGAN;452927;28032025
function CirrhosisViolance() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
      "success"
    );
const showAlert = (message: string, severity: "error" | "success") => {
  setAlertMessage(message);
  setAlertSeverity(severity);
  setAlertOpen(true);
};
const handleSaveMedcard = async () => {
  try {
    const response = "Medcard Kaydedildi";
    console.log("Save API cevabı:", response);
    showAlert(response, "success");
  } catch (error) {
    console.error("Hata:", error);
    showAlert("Medcard kaydedilirken hata oluştu!", "error");
  }
};

const handleDeleteMedcard = async () => {
  try {
    const response = "Medcard Silindi";
    console.log("Delete API cevabı:", response);
    showAlert(response, "success");
  } catch (error) {
    console.error("Hata:", error);
    showAlert("Medcard silinirken hata oluştu!", "error");
  }
};
  const { t } = useTranslate();
  return (
    <>
    <Stack
          sx={{ padding: "5px", marginBottom: "20px" }}
          mt={5}
          direction="row"
          spacing={2}
      >
      <ByzNurseSaveButton onClick={handleSaveMedcard} />
      <ByzMuiAddButton />
      <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
      <ByzNursePrintButton2 />
    </Stack>
    <Box sx={{ padding: "20px", width: "100%" }}>
      <Grid container spacing={2}>
        <Grid md={6} xs={6} container direction={"column"} spacing={3}>
        <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography
              sx={{ display: "flex", textAlign: "center" }}
              fontWeight={500}
              fontSize={"14px"}
              isTitle
            >
              {t("cirrhosis-violance.determination-cirrhosis")}
            </ByzMuiTypography>
          </Grid>
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("datetime")}</ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6}>
              <ByzMuiDateTimePicker sx={{ width: "300px" }} />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("createdby")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiTextField
                sx={{ width: "300px" }}
                color="info"
                label={t("createdby")}
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography
              sx={{ display: "flex", textAlign: "center" }}
              fontWeight={500}
              fontSize={"14px"}
              isTitle
            >
              {t("cirrhosis-violance.parameters")}
            </ByzMuiTypography>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("cirrhosis-violance.total-bilirubin")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("cirrhosis-violance.total-bilirubin")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "235px" }}
                color="info"
                label={t("select")}
                placeholder={t("select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("cirrhosis-violance.albumin")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("cirrhosis-violance.albumin")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "235px" }}
                color="info"
                label={t("select")}
                placeholder={t("select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("cirrhosis-violance.inr")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("cirrhosis-violance.inr")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "235px" }}
                color="info"
                label={t("select")}
                placeholder={t("select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("cirrhosis-violance.ascites")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("cirrhosis-violance.ascites")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "235px" }}
                color="info"
                label={t("select")}
                placeholder={t("select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("cirrhosis-violance.hepatic-encephalopathy")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("cirrhosis-violance.hepatic-encephalopathy")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "235px" }}
                color="info"
                label={t("select")}
                placeholder={t("select")}
              />
            </Grid>
          </Grid>
          <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography
              sx={{ display: "flex", textAlign: "center" }}
              fontWeight={500}
              fontSize={"14px"}
              isTitle
            >
              {t("other")}
            </ByzMuiTypography>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("score")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiTextField sx={{ width: '300px' }} color='info' disabled label={t("score")} variant="outlined" />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("note")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiTextField sx={{ width: '300px' }} color='info' label={t("note")} variant="outlined" />
            </Grid>
          </Grid>

        </Grid>
      </Grid>
    </Box>
    </>
  );
}

export default CirrhosisViolance;
